import React from "react";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DownloadWarningModal({ isOpen, onClose, onConfirm, title = "Dokument herunterladen", type = "general" }) {
  if (!isOpen) return null;

  const warningText = type === "invoice" ? (
    <p className="text-sm text-slate-700 leading-relaxed">
      <strong>Hinweis:</strong> Diese Rechnung wurde automatisch erstellt. 
      Der Betreiber der Anwendung übernimmt <strong>keine Gewähr für die Richtigkeit, 
      Vollständigkeit oder steuerliche Rechtmäßigkeit</strong> der Angaben. 
      Bitte prüfen Sie die Rechnung vor Verwendung eigenständig.
    </p>
  ) : (
    <p className="text-sm text-slate-700 leading-relaxed">
      <strong>Hinweis:</strong> Dieses Dokument wurde automatisch erstellt. 
      Trotz sorgfältiger Programmierung kann <strong>keine Gewähr für die Richtigkeit, 
      Vollständigkeit oder Aktualität</strong> der enthaltenen Informationen übernommen werden. 
      Bitte prüfen Sie alle Angaben eigenständig, bevor Sie das Dokument verwenden oder weitergeben.
    </p>
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
        <div className="flex items-center justify-center mb-4">
          <div className="bg-amber-100 p-3 rounded-full">
            <FileText className="w-8 h-8 text-amber-600" />
          </div>
        </div>
        
        <h2 className="text-xl font-bold text-slate-800 text-center mb-4">
          {title}
        </h2>
        
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          {warningText}
        </div>

        <div className="flex gap-3">
          <Button 
            onClick={onClose}
            variant="outline"
            className="flex-1"
          >
            Abbrechen
          </Button>
          <Button 
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="flex-1 bg-emerald-600 hover:bg-emerald-700"
          >
            Verstanden, herunterladen
          </Button>
        </div>
      </div>
    </div>
  );
}
